module.exports = BD.Model.extend({
    invoice: BD.belongsTo('Billy.OrganizationInvoice', { isParent: true }),
    description: BD.attr('string', { readonly: true }),
    price: BD.attr('number', { readonly: true }),
    discountText: BD.attr('string', { readonly: true }),
    discount: BD.attr('number', { readonly: true }),
    amount: BD.attr('number', { readonly: true }),
    tax: BD.attr('number', { readonly: true })
})
